import "core-js/modules/es6.object.define-property";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import React from 'react';
var contextSymbol = typeof Symbol === 'function' && Symbol["for"] ? Symbol["for"]('__APOLLO_CONTEXT__') : '__APOLLO_CONTEXT__';
export function resetApolloContext() {
  Object.defineProperty(React, contextSymbol, {
    value: React.createContext({}),
    enumerable: false,
    configurable: true,
    writable: false
  });
}
export function getApolloContext() {
  if (!React[contextSymbol]) {
    resetApolloContext();
  }

  return React[contextSymbol];
}